<template>

    <div v-if="server_teamStatus_c && server_currentUserData_c && server_questBody_c">


        <c_-ongoing_-quest_-cards-riddles
                v-if="server_questBody_c "

                :p_system_lang-code_e="store_system_langCode_ve.val"
                :p_qb_display-lang-code_e="server_questBody_c.cm_qb_getDisplayLangCode_e(store_system_langCode_ve.val)"
                :p_system_display-keyboard_b="store_system_displayKeyboard_vb.val"
                :p_show-nav-btns_b="true"
                :p_current-user-id_uid="server_currentUserData_c.ud_userId_uid"
                :p_system_window-size-type_en="store_system_windowSizeType_ve.val"
                :p_team-status_sub-collection_e="enum_subCollection_teamStatus.LIST_LAST_MISSIONS"

                :p_available-riddles-indexes_a="co_availableRiddlesIndex_a"
                :p_show-skip-btn_by-riddle-index="{}"
                :p_riddles-status_by-riddle-index_c="server_ts_lastRiddles_byRiddleIndex_c"

                :p_qbr_map-data_ac="co_qb_riddleMapData_ac"
                :p_qb_riddles_ac="server_questBody_c.qb_listLastMissions_ac"
                :p_riddles-metadata_ac="co_riddlesMetadata_ac"
                :p_qbr_themes_ac="co_qbr_themes_ac"
                :p_total-riddle-num_n="server_questBody_c.qb_listLastMissions_ac.length"

                :p_current-riddle-index_n="store_cardsRiddles_lastIndex_n != null ? store_cardsRiddles_lastIndex_n : 0"

                :p_qb_metadata_c="server_questBody_c.qb_metadata_c"

                :p_skips-left_n="server_teamStatus_c.ts_skipsLeft_n"
                :p_clues-left_n="server_teamStatus_c.ts_cluesLeft_n"

                :p_current-user-location_c="store_system_position_vc.val"

                :pe_start-watch-position_f="pe_startWatchPosition_f"
                :pe_stop-watch-position_f="pe_stopWatchPosition_f"
                :p_click-get-clue_f="m_clickGetClue_f"
                :p_click-skip-riddle_f="() => {}"
                :p_update-riddle-lock-answer_f="m_updateRiddleLock_f"/>

    </div>
    <div v-else class="TQ_center">
        <ball-pulse-sync-loader color="#2E294E" size="10px"/>
    </div>

</template>

<script>
import {
    enum_finishQuest_s,
    enum_subCollection_teamStatus
} from "../../../../functions/src/shareCode/Share_S_Enum";
    import {store_var, store_getStateValue_vo} from "../../../store";
    import {
        helper_finishRiddle_fb,
    } from "../../../scripts/S_Helper";
    import {
        route_moveToRoute,
        route_currentPath_s
    } from "../../../router";
    import C_Ongoing_Quest_CardsRiddles from "../V_Ongoing_Cards/C_Ongoing_Quest_CardsRiddles";
    import {
        serverOngoing_teamStatus_subCollection_cl_get_f,
        serverOngoing_teamStatus_subCollection_cl_remove_f,
        serverOngoing_teamStatusSub_riddleStatus_unlockData_update_f,
        serverOngoing_teamStatus_riddleStatus_useClue_update_f,
        serverOngoing_teamStatus_vl_set_f,
        serverOngoing_teamStatus_vl_remove_f,
        serverOngoing_setFinishTime_f,
        serverOngoing_gameStatus_updateTotalPoints_f
    } from "../../../scripts/Server/S_ServerOngoing";
    import {
        serverAuth_currentUserData_remove_vl_f
    } from "../../../scripts/Server/S_ServerAuth";
    import {serverBig_questBody_once_fp} from "../../../scripts/Server/S_ServerFirestore";
    import TqRiddleData from "../../../components/complex/TqRiddleData";
    import TqCard from "../../../components/basic/TqCard";
    import {
        enum_moveToOptions,
    } from "../../../../functions/src/shareCode/Share_S_Enum";
    import {serverAuth_currentUserData_get_vl_fp} from "../../../scripts/Server/S_ServerAuth";

    export default {
        name        : "V_Ongoing_Missions_Last",
        components  : {
            TqCard,
            TqRiddleData,
            C_Ongoing_Quest_CardsRiddles
        },
        props:{
            pe_startWatchPosition_f:{
                type: Function,
                require: true
            },
            pe_stopWatchPosition_f:{
                type: Function,
                require: true
            }
        },
        data() {
            return {

                // store
                store_system_langCode_ve        : store_getStateValue_vo(store_var.system_langCode),
                store_system_position_vc        : store_getStateValue_vo(store_var.system_currentUserLocation),
                store_system_displayKeyboard_vb : store_getStateValue_vo(store_var.system_displayKeyboard_b),
                store_system_windowSizeType_ve  : store_getStateValue_vo(store_var.system_windowSizeType_e),
                store_questEvent_c              : store_getStateValue_vo(store_var.ongoing_questEvent).val,
                store_currentTeamId_uid         : store_getStateValue_vo(store_var.ongoing_currentTeamId_uid).val,
                store_cardsRiddles_lastIndex_n  : store_getStateValue_vo(store_var.ongoing_cardsRiddles_lastIndex_n).val,

                // server
                server_teamStatus_c               : undefined,
                server_currentUserData_c          : undefined,
                server_questBody_c                : undefined,
                server_ts_lastRiddles_byRiddleIndex_c: {},

                // imports
                enum_subCollection_teamStatus     : enum_subCollection_teamStatus
            }
        },
        computed:{

            co_availableRiddlesIndex_a(){

                let ans = []

                for(let lastRiddleIndex_n=0; lastRiddleIndex_n < this.server_questBody_c.qb_listLastMissions_ac.length; lastRiddleIndex_n++){

                    ans.push(lastRiddleIndex_n)


                    if(!helper_finishRiddle_fb(
                        this.server_questBody_c.qb_listLastMissions_ac[lastRiddleIndex_n],
                        this.server_ts_lastRiddles_byRiddleIndex_c[lastRiddleIndex_n])){
                        break;
                    }
                }

                return ans
            },
            co_riddlesData_ac(){

                return this.server_questBody_c.qb_listLastMissions_ac
            },
            co_qb_riddleMapData_ac(){

                let ans = []

                for(let i=0 ; i<this.server_questBody_c.qb_listLastMissions_ac.length; i++){
                    ans.push(this.server_questBody_c.qb_listLastMissions_ac[i].qbr_mapData_c)
                }


                return ans
            },
            co_riddlesMetadata_ac(){

                let ans = []

                for(let i=0 ; i<this.server_questBody_c.qb_listLastMissions_ac.length; i++){
                    ans.push(this.server_questBody_c.qb_listLastMissions_ac[i].qbr_metadata_c)
                }

                return ans
            },
            co_qbr_themes_ac(){

                let ans = []

                for(let i=0 ; i<this.server_questBody_c.qb_listLastMissions_ac.length; i++){
                    ans.push(this.server_questBody_c.qb_listLastMissions_ac[i].qbr_theme_c)
                }

                return ans
            },

            co_riddlesIndex_byRiddleId_n (){
                let ans_o = {}
                this.server_questBody_c.qb_listLastMissions_ac.forEach((qb_riddle_c, index_n) =>{
                    ans_o[qb_riddle_c.qbr_riddleId_n] = index_n
                })

                return ans_o
            }
        },
        methods: {
            m_clickGetClue_f(riddleIndex_n, clueIndex_n, cb_f) {

                serverOngoing_teamStatus_riddleStatus_useClue_update_f({
                    questEvent_c: this.store_questEvent_c,
                    teamId_uid  : this.store_currentTeamId_uid,
                    userId_uid  : this.server_currentUserData_c.ud_userId_uid,
                    teamStatus_subCollection_e: enum_subCollection_teamStatus.LIST_LAST_MISSIONS,
                    riddleData_c: this.server_questBody_c.qb_listLastMissions_ac[riddleIndex_n],
                    teamStatus_c: this.server_teamStatus_c,

                    clueId_n    : clueIndex_n,
                    clueMode_e  : this.server_questBody_c.qb_metadata_c.qbm_missions_cluesMode_e,
                    cb_f        : cb_f

                })
            },
            m_updateRiddleLock_f(riddleIndex_n, lockIndex_n, rs_unlocksData_c, cb_f) {

                serverOngoing_teamStatusSub_riddleStatus_unlockData_update_f({
                    questEvent_c: this.store_questEvent_c,
                    teamId_uid: this.store_currentTeamId_uid,
                    userId_uid: this.server_currentUserData_c.ud_userId_uid,
                    teamStatus_subCollection_e: enum_subCollection_teamStatus.LIST_LAST_MISSIONS,

                    lockIndex_n                 : lockIndex_n,
                    rs_lockData_c               : rs_unlocksData_c,
                    riddleData_c                : this.server_questBody_c.qb_listLastMissions_ac[riddleIndex_n],

                    questSupportPoints_b        : this.server_questBody_c.qb_metadata_c.qbm_missions_supportMissionsPoints_b,

                    questLastRiddle_b           : this.server_questBody_c.qb_metadata_c.qbm_quest_finishQuest_e === enum_finishQuest_s.listMissions_last,
                    riddleStatus_c              : this.co_availableRiddlesIndex_a.indexOf(riddleIndex_n)+ 1 === this.co_availableRiddlesIndex_a.length,

                    cb_f : cb_f
                })
            },

        },

        // life circle
        created(){


            // 1) get currentUserData
            serverAuth_currentUserData_get_vl_fp(this.$options.name, (currentUserData) => {
                this.server_currentUserData_c = currentUserData;
            })

            // 2) get teamStatus
            serverOngoing_teamStatus_vl_set_f({
                viewName_s: this.$options.name, 
                questEvent_c : this.store_questEvent_c, 
                teamId_uid : this.store_currentTeamId_uid,
                cb_f: (teamStatus_c) => {
                    this.server_teamStatus_c = teamStatus_c;
                }
            })
                

            // 4) questBody
            serverBig_questBody_once_fp(this.store_questEvent_c.qev_questType_e, this.store_questEvent_c.qev_questId_uid, false, true, (questBody_c)=>{
                this.server_questBody_c = questBody_c

                // 5) get teamStatus subCollection last riddles
                serverOngoing_teamStatus_subCollection_cl_get_f({
                    viewName_s: this.$options.name,
                    subCollectionName_e: enum_subCollection_teamStatus.LIST_LAST_MISSIONS,
                    questEvent_c: this.store_questEvent_c,
                    teamId_uid: this.store_currentTeamId_uid,
                    cb_ChildAdded_f : (riddleStatus_c) => {
                        this.$set(this.server_ts_lastRiddles_byRiddleIndex_c, this.co_riddlesIndex_byRiddleId_n[riddleStatus_c.rs_riddleId_n], riddleStatus_c)
                    }
                })

            })

        },
        activated(){
            // TODO : check when lazy load working here

            if(route_currentPath_s(this.$route).includes(enum_moveToOptions.ongoing_quest_openMap_map)){
                route_moveToRoute(enum_moveToOptions.ongoing_quest_openMap_riddle)
            }

        },
        destroyed(){

            // 1) current user
            serverAuth_currentUserData_remove_vl_f(this.$options.name)

            // 2) team status
            serverOngoing_teamStatus_vl_remove_f(this.$options.name, this.store_questEvent_c, this.store_currentTeamId_uid)

            // 3) teamStatus subCollection last riddles
            serverOngoing_teamStatus_subCollection_cl_remove_f({
                viewName_s          : this.$options.name,
                subCollectionName_e : enum_subCollection_teamStatus.LIST_LAST_MISSIONS,
                questEvent_c        : this.store_questEvent_c,
                teamId_uid          : this.store_currentTeamId_uid,
            })

        },

    }
</script>

<style scoped lang="scss">
</style>